import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DocumentsAndDeclarationContent } from "../../TopUpWithITFLSWizard/Resource/Contents";

export const EditIncomeWithdrawalsSteppersMap = {
    incomePaymentDetails: "Income payment details",
    review: "Review",
    DocumentsAndDeclarations:"Documents & declarations",
    confirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Wrap Cash",
};


export const editIncomePaymentDetailsLabels = {
        targetSpecificArrangements: "Do you wish to target specific arrangements?",
        targetSpecificArrangementsTooltip: "Where a customer has more than one drawdown arrangement, you are able to choose which arrangements are used to provide income withdrawals. Selecting specific arrangements can be beneficial for clients who have inherited drawdown benefits which have different tax treatments. Or you can select 'No' and the platform will automatically choose the arrangements to be used.",
    takeDifferentInitialIncomePaymentTooltip: "We offer a different initial income payment; this could be used to take a one-off taxable withdrawal or an alternative first payment followed by a regular income payment of a different amount.",
        takeDifferentInitialIncomePayment: "Do you wish to take a different initial income payment?",
        grossInitialIncomePayment: "Gross initial income payment",
        maximumInitialIncomePayment: "Maximum for initial income payment",
        maximumIncomePerPayment: "Maximum income per payment",
        grossIncomePerPayment: "Gross income per payment",
        grossIncomePerPaymentFromPension: "Gross income per payment from the pension",
        incomeFrequency: "Income frequency",
        firstPaymentDate: "First payment date"
};